<template>
    <div class="content">
        <!-- <base-header class="pb-6">
            <div class="row align-items-center py-2">
                <div class="col-lg-6 col-7"></div>
            </div>
        </base-header> -->

        <div class="row">
            <div class="col-xl-12">

                <div class="dash-head-wrap d-flex justify-content-between align-items-center">
                    <div class="dash-header mb-4">
                        <h2 class="text-default m-0 d-flex">{{ isSafeDig ? 'Course Resources' : 'Guides and Downloads' }} <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="">
                        </h2>
                        <p class="text-secondary">Your course materials and important documents</p>
                    </div>
                    <!-- <base-button type="primary"
                        class="font-weight-normal px-4 d-none d-sm-block">
                        Add New</base-button> -->
                </div>
            </div>
        </div>
        <div class="document_resources_wrap">
            <div>
                    <template v-if="isSafeDig && !isCompanySideForDocuments">
                        <employee-resources></employee-resources>
                    </template>
                    <template v-else-if="isSafeDig && isCompanySideForDocuments">
                    <div class="row justify-content-sm-between flex-wrap location-form mb-4">
                        <div class="col-md-6 col-lg-6 col-xl-7 d-flex align-items-center search-style">
                            <h2 class="mb-0">Resources & Documents</h2>
                        </div>
                    </div>
                        <tabs :defaultIndex="0">
                            <tab name="Resources" title="Resources">
                                <employee-resources></employee-resources>
                            </tab>
                            <tab name="Onboarding Documents" title="Onboarding Documents">
                                <user-onboarding-report></user-onboarding-report>
                            </tab>
                            <tab name="Other" title="Other">
                                <card class="no-border-card card-with-table" footer-classes="pt-1">
                                <div class="row">
                                    <div class="col-md-12 user-eltable table-style-normal no-header-bg">
                                        <el-table :data="tbl_data" class="resourceGride" header-row-class-name="thead-light custom-thead-light" role="table">
                                            <el-table-column align="left" label="Resource Name" min-width="250px">
                                                <template slot-scope="propsss">
                                                    <span>{{ propsss.row.document_name }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="left" label="Resource Description" min-width="250px" class-name="left-align">
                                                <template slot-scope="propsss">
                                                    <span>{{ propsss.row.document_description }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="left" class="table-custom-size" label="Action" min-width="150px">
                                                <template slot-scope="propsss">
                                                    <div class="row">
                                                        <div class="col-md-1">
                                                            <button
                                                              v-if="propsss.row.document_type === 'file' && propsss.row.document"
                                                              type="button"
                                                              class="doc-action-btn"
                                                              title="Download Resource"
                                                              @click.prevent="downloadFile({
                                                                url: downloadUrl + '/employee/documents/' + propsss.row.document,
                                                                name: propsss.row.document
                                                              })"
                                                            >
                                                              Download
                                                            </button>

                                                            <a
                                                              v-if="propsss.row.document_type == 'link' && propsss.row.document_url != null"
                                                              :href="propsss.row.document_url"
                                                              class="doc-action-link"
                                                              target="_blank"
                                                              title="Open Link"
                                                            >
                                                              Open Link
                                                            </a>
                                                        </div>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                                </card>
                            </tab>
                        </tabs>
                    </template>
                    <template v-else>
                    <div class="row justify-content-sm-between flex-wrap location-form mb-4">
                        <div class="col-md-6 col-lg-6 col-xl-7 d-flex align-items-center search-style">
                            <h2 class="mb-0">Resources & Documents</h2>
                        </div>
                    </div>
                        <tabs :defaultIndex="0">
                            <tab name="Resources" title="Resources">
                                <employee-resources></employee-resources>
                            </tab>
                            <tab v-if="this.company_level == 'parent'" name="Company Forms" title="Company Forms">
                                <hr-form></hr-form>
                            </tab>
                            <tab name="My Company Forms" title="My Company Forms">
                                <hr-form-employee></hr-form-employee>
                            </tab>
                            <tab v-if="this.editor != 'employee'" name="Onboarding Documents" title="Onboarding Documents">
                                <user-onboarding-report></user-onboarding-report>
                            </tab>
                            <tab v-if="this.editor != 'employee'" title="Employee Documents">
                                <div>
                                    <card class="no-border-card card-with-table" footer-classes="pt-1">
                                    <div>
                                        <div class="row">
                                            <div class="col-md-12 user-eltable table-style-normal no-header-bg">
                                                <el-table  :data="tbl1_data" class="employeeresGrid" header-row-class-name="thead-light custom-thead-light" role="table" row-key="id">
                                                    <el-table-column align="left" label="" min-width="180px" prop="first_name">
                                                        <template slot="header">
                                                            <span> Full Name </span>
                                                        </template>
                                                        <template slot-scope="props">
                                                            <!-- <img data-v-77040714="" src="img/theme/avatar.svg" width="36" height="36" class="profile-img"> -->
                                                            {{ props.row.first_name + props.row.last_name }}
                                                        </template>
                                                    </el-table-column>
                                                    <!-- <el-table-column align="left" label="" min-width="180px" prop="last_name">
                                                        <template slot="header">
                                                            <span>Last Name </span>
                                                        </template>
                                                        <template slot-scope="props">
                                                            {{ props.row.last_name }}
                                                        </template>
                                                    </el-table-column> -->
                                                    <el-table-column align="left" label="" min-width="180px" prop="location">
                                                        <template slot="header">
                                                            <span>Location </span>
                                                        </template>
                                                        <template slot-scope="props">
                                                            {{ props.row.location }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column align="left" label="" min-width="100px" prop="date">
                                                        <template slot="header">
                                                            <span>Date </span>
                                                        </template>
                                                        <template slot-scope="props">
                                                            {{ props.row.date }}
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column align="left" label="Document" min-width="200px" prop="document">
                                                        <template slot-scope="props">
                                                            <span v-if="props.row.id">
                                                                <a :href="downloadUrl + '/hr-forms/' + props.row.file_url">{{ props.row.document_name }}</a>
                                                            </span>
                                                            <span v-else> {{ props.row.document_name }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column align="left" class="table-custom-size" label="Action" min-width="150px">
                                                        <template slot-scope="props">
                                                            <div class="row">
                                                                <div class="col-md-1">
                                                                    <span v-if="props.row.id">
                                                                        <el-tooltip content="Download" placement="top">
                                                                            <button
                                                                              type="button"
                                                                              class="doc-action-btn"
                                                                              data-original-title="Download"
                                                                              data-toggle="tooltip"
                                                                              @click="handleView(props.row)"
                                                                            >
                                                                              Download
                                                                            </button>
                                                                        </el-tooltip>
                                                                    </span>
                                                                    <span v-else>
                                                                        <a
                                                                          v-if="props.row.document_type == 'file' && props.row.document != null"
                                                                          :href="downloadUrl + '/employee/documents/' + props.row.document"
                                                                          class="doc-action-link"
                                                                          target="_blank"
                                                                          title="Open Resource"
                                                                        >
                                                                          Open File
                                                                        </a>
                                                                        <a v-if="props.row.document_type == 'link' && props.row.document_url != null" :href="props.row.document_url" class="doc-action-link" target="_blank" title="Open Link">
                                                                            Open Link
                                                                        </a>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </div>
                                        </div>
                                    </div>
                                    </card>
                                </div>
                            </tab>
                            <tab name="Other" title="Other">
                                <card class="no-border-card card-with-table" footer-classes="pt-1">
                                <div class="row">
                                    <div class="col-md-12 user-eltable table-style-normal no-header-bg">
                                        <el-table :data="tbl_data" class="resourceGride" header-row-class-name="thead-light custom-thead-light" role="table">
                                            <el-table-column align="left" label="Resource Name" min-width="250px">
                                                <template slot-scope="propsss">
                                                    <span>{{ propsss.row.document_name }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="left" label="Resource Description" min-width="250px" class-name="left-align">
                                                <template slot-scope="propsss">
                                                    <span>{{ propsss.row.document_description }}</span>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="left" class="table-custom-size" label="Action" min-width="150px">
                                                <template slot-scope="propsss">
                                                    <div class="row">
                                                        <div class="col-md-1">
                                                            <!-- <a v-if="propsss.row.document_type == 'file' && propsss.row.document != null" :href="downloadUrl + '/employee/documents/' + propsss.row.document" style="color: white"  title="Download Resource" download>
                                                                <img class="ico-download" src="/img/icons/common/download_icon.svg" alt="" />
                                                            </a> -->
                                                            <button
                                                              v-if="propsss.row.document_type === 'file' && propsss.row.document"
                                                              type="button"
                                                              class="doc-action-btn"
                                                              title="Download Resource"
                                                              @click.prevent="downloadFile({
                                                                url: downloadUrl + '/employee/documents/' + propsss.row.document,
                                                                name: propsss.row.document
                                                              })"
                                                            >
                                                              Download
                                                            </button>

                                                            <a
                                                              v-if="propsss.row.document_type == 'link' && propsss.row.document_url != null"
                                                              :href="propsss.row.document_url"
                                                              class="doc-action-link"
                                                              target="_blank"
                                                              title="Open Link"
                                                            >
                                                                Open Link
                                                            </a>
                                                        </div>
                                                    </div>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                                </card>
                            </tab>
                        </tabs>
                    </template>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import {Option, Select, Table, TableColumn} from "element-ui";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import HrForm from "./HrForm.vue";
import HrFormEmployee from "./HrFormEmployee.vue";
import UserOnboardingReport from "./UserOnboardingReport.vue";
import EmployeeResources from "./EmployeeResources.vue";
import "sweetalert2/src/sweetalert2.scss";
import {Tab, Tabs} from "vue-slim-tabs";
import moment from "moment";
import axios from "axios";

Vue.use(Tabs);

export default {
    mixins: [serverSidePaginationMixin],
    components: {
        //BasePagination,
        HrForm,
        HrFormEmployee,
        UserOnboardingReport,
        EmployeeResources,
        Tabs,
        Tab,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data() {
        return {
            baseUrl: this.$baseUrl,
            downloadUrl: this.$downloadUrl,
            hot_user: "",
            hot_token: "",
            user_id: "",
            tbl_data: [],
            tbl1_data: [],
            editor: "",
            company_level: "",
        };
    },
    created: function () {
        if (localStorage.getItem("hot-token")) {
            this.hot_user = localStorage.getItem("hot-user");
            this.hot_token = localStorage.getItem("hot-token");
            if (this.hot_user === "company-admin") {
                this.user_id = localStorage.getItem("hot-admin-id");
                this.company_level = localStorage.getItem("hot-company-level");
            } else {
                this.user_id = localStorage.getItem("hot-user-id");
            }
        }
        if (localStorage.getItem("hot-user") === "employee") {
            this.editor = "employee";
        }
        const isSafeDigBuild = process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig";
        const isCompanySide =
            this.hot_user === "company-admin" || this.hot_user === "manager";
        if (isSafeDigBuild && !isCompanySide) {
            return;
        }
        this.$http
            .post("employees/documents", {
                employee_id: this.user_id,
            })
            .then((resp) => {
                let document_data = resp.data;
                for (let data of document_data) {
                    let obj = {
                        document: data.document,
                        document_name: data.title,
                        document_type: data.type,
                        document_description: data.description,
                        document_url: data.url,
                    };
                    this.tbl_data.push(obj);
                }
            });
        if (!(isSafeDigBuild && isCompanySide)) {
            this.fetchData();
        }
    },
    methods: {
   async downloadFile(file) {
      try {
        const response = await this.$http.post("force-download", {
          file: file
        }, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.name || 'downloaded-file');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Download failed:", error);
        this.$swal({
          title: "Error",
          text: "Failed to download file.",
          icon: "error",
        });
      }
  },
        fetchData() {
            this.tbl1_data = [];
            this.$http
                .post("employees/employee_documents", {
                    column: this.sortedColumn,
                    order: this.order,
                })
                .then((resp) => {
                    let employee_document_data = resp.data;
                    for (let data of employee_document_data) {
                        let obj1 = {
                            first_name: data.first_name,
                            last_name: data.last_name,
                            location: data.location,
                            date: moment(data.created_at).format("MM-DD-YYYY"),
                            document: data.document,
                            document_name: data.title,
                            document_type: data.type,
                            document_url: data.url,
                        };
                        this.tbl1_data.push(obj1);


                    }


                });
            this.$http
                .post("resources/hr_form_report", {
                    search: this.searchQuery,
                    page: this.currentPage,
                    column: this.sortedColumn,
                    per_page: this.perPage,
                })
                .then((resp) => {
                    this.tableData = [];
                    let report_data = resp.data.report;
                    let total_data = resp.data.total;
                    this.totalData = total_data;
                    for (let data of report_data) {
                        let obj = {
                            id: data.id,
                            first_name: data.first_name,
                            last_name: data.last_name,
                            date: moment(data.created_at).format("MM-DD-YYYY"),
                            location: data.location,
                            document_name: data.name,
                            file_url: data.file,
                            document_url: data.upload,
                        };
                        this.tbl1_data.push(obj);
                    }

                })
                .finally(() => (this.loading = false));
        },
        async handleView(file) {
            let row = file.document_url;
            await this.$http
                .post("resources/download-hr-forms", {
                    id: file.id,
                    type: "Employee Documents",
                    file:file.document_url,
                    user:"emp"
                },{ responseType: "blob" })
                .then((response) => {
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = file.document_url;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                    // let extension = row.split(".").pop();
                    // if (extension == "pdf") {
                    //     let filenameNew = row.split(".pdf");
                    //     axios
                    //         .get(this.downloadUrl + "/resources/download_uploads/" + filenameNew[0], {
                    //             responseType: "arraybuffer",
                    //         })
                    //         .then((res) => {
                    //             let blob = new Blob([res.data], {type: "application/pdf"});
                    //             let link = document.createElement("a");
                    //             link.href = window.URL.createObjectURL(blob);
                    //             link.download = row;
                    //             link.click();
                    //         });
                    // } else {
                    //     window.open(this.downloadUrl + "/hr-forms/user-uploads/" + row, "_blank").focus();
                    // }
                });
        },
    },
    computed: {
        isSafeDig() {
            return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
        },
        isCompanySideForDocuments() {
            return (
                this.hot_user === 'company-admin' ||
                this.hot_user === 'manager'
            );
        },
    },
};
</script>
<style scoped>
.no-border-card .card-footer {
    border-top: 0;
}

.doc-action-btn,
.doc-action-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 92px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #cfd7e5;
    background: #ffffff;
    color: #2d4f85;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s ease;
}

.doc-action-btn:hover,
.doc-action-link:hover {
    border-color: #2d4f85;
    background: #f5f8ff;
}

.doc-action-btn {
    cursor: pointer;
}

@media only screen and (max-width: 1024px), (min-device-width: 768px) and (max-device-width: 1024px) {
    .resourceGride >>> table.el-table__body td:nth-of-type(1):before {
        content: "Resource Name";
    }

    .resourceGride >>> table.el-table__body td:nth-of-type(2):before {
        content: "Resource Description";
    }

    .resourceGride >>> table.el-table__body td:nth-of-type(3):before {
        content: "Action";
    }

    .employeeresGrid >>> table.el-table__body td:nth-of-type(1):before {
        content: "Full Name";
    }

    .employeeresGrid >>> table.el-table__body td:nth-of-type(2):before {
        content: "Location";
    }

    .employeeresGrid >>> table.el-table__body td:nth-of-type(3):before {
        content: "Date";
    }
    .employeeresGrid >>> table.el-table__body td:nth-of-type(4):before {
        content: "Document";
    }
    .employeeresGrid >>> table.el-table__body td:nth-of-type(5):before {
        content: "Action";
    }
}



</style>
<style src="vue-slim-tabs/themes/default.css"></style>
